import {PageTypeEnum} from '@doltech/utils/lib/constants';
import {types as t} from 'mobx-state-tree';
import {useStore} from 'mobx-store-provider';

export const LandingSEOPageDataStore = t
  .model('LandingSEOPageDataStore', {
    initial: t.optional(t.boolean, false),
    pageData: t.string,
    seoData: t.string,
  })
  .views((self) => ({
    getExplanationLink() {
      const pageData = JSON.parse(self.pageData);
      const explanationLink = (pageData?.pages || []).find(
        (item) => item?.templateTypeId === PageTypeEnum.VIEW_SOLUTION,
      )?.url;
      return explanationLink || '#';
    },
    getDoTestLink() {
      const pageData = JSON.parse(self.pageData);
      const doTestLink = (pageData?.pages || []).find(
        (item) => item?.templateTypeId === PageTypeEnum.DO_TEST,
      )?.url;
      return doTestLink || '#';
    },
  }));

export const getInitializeLandingSEOPageDataStore = ({ pageData, seoData }) => {
  return {
    initialed: true,
    pageData: JSON.stringify(pageData),
    seoData: JSON.stringify(seoData),
  };
};

export const useLandingSeoPageDataStore = () => {
  return useStore(LandingSEOPageDataStore);
};
